import axios from "axios";
import { API_PATHS } from "@config/constants";

export const getPacks = async () => {
  const { data, status } = await axios.get(API_PATHS.packs);
  if (status !== 200 || data?.success === false) {
    throw new Error(data.errorMessage || "Can't get packs!");
  }

  return data.data;
};
